<template>
    <div>
        <div class="my-5">
            <div class="d-flex justify-content-between align-items-end mb-3">
                <h4 class="mb-0">{{ $t('vendorContacts.title') }}</h4>
                <b-button variant="success" @click="onNewContactModal">
                    <b-icon icon="person-plus" class="mr-1"></b-icon>
                    {{ $t('vendorContacts.addContact') }}
                </b-button>
            </div>
            <contact-list
                ref="contactList"
                :company-id="resource.id"
                :company-name="resource.name"
                :hide-fields="['company_name']"
                @list-loaded="onContactsLoaded"
            ></contact-list>

            <contact-create-update-modal
                ref="contactModal"
                hide-save-redirect
                :company-data="resource"
                :redirect-after-create="false"
                @create-complete="onRefreshContactList"
            ></contact-create-update-modal>
        </div>
    </div>
</template>

<script>
import ContactList from "@/components/ContactList";
import ContactCreateUpdateModal from "@/components/ContactCreateUpdateModal";

export default {
    components: {
        ContactList,
        ContactCreateUpdateModal,
    },
    i18n: {
        messages: {
            en: {
                vendorContacts: {
                    title: "Contacts",
                    addContact: "Add Contact",
                },
            },
            es: {
                vendorContacts: {
                    title: "Contactos",
                    addContact: "Agregar Contacto",
                },
            },
            pt: {
                vendorContacts: {
                    title: "Contatos",
                    addContact: "Adicionar Contato",
                },
            },
            "zh-Hans": {
                vendorContacts: {
                    title: "联系人",
                    addContact: "添加联系人",
                },
            },
            "zh-Hant": {
                vendorContacts: {
                    title: "聯絡人",
                    addContact: "新增聯絡人",
                },
            },
        },
    },
    props: ["resource"],
    methods: {
        onContactsLoaded() {
            // ContactList will emit its number of contacts, but its not what we want - because the list might be filtered, not all active contacts for this company
            // so we will emit resource:updated, but don't pass up new data
            this.$emit("resource:updated");
        },
        onRefreshContactList() {
            this.$refs.contactList.refreshList();
        },
        onNewContactModal() {
            this.$refs.contactModal.startCreate();
        },
    },
};
</script>
